import { notification } from "../../TailwindNotification";

const CustomToster = (data) => {
    // Ensure message is a string, not an object
    let message = '';
    if (data?.message) {
        if (typeof data.message === 'string') {
            message = data.message;
        } else if (typeof data.message === 'object') {
            // If message is an object, try to extract string from it
            message = data.message.message || data.message.name || JSON.stringify(data.message);
        } else {
            message = String(data.message);
        }
    }

    if(data?.type === 'success'){
        notification.success({
            message: `Congratulations`,
            description: message
        });
    }
    else if(data?.type === 'warning'){
        notification.warning({
            message: `Warning`,
            description: message
        });
    }
    else {
        notification.error({
            message: `Error`,
            description: message
        });
    }
   
}
export default CustomToster;